var DB_Medias = {
    init:function(){   
        /*
        if(document.querySelectorAll(".DB-medias .logos-container.swiper-container").length > 0){
            var swiper_logos = new Swiper(document.querySelector(".DB-medias .logos-container.swiper-container"), {
                  slidesPerView: "auto",
                  spaceBetween: 30,
                  freeMode:true,
                  loop:true,
                  autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                  },
                });
          }
        */
        if(document.querySelectorAll(".DB-medias .text-container.swiper-container").length > 0){        
            var _swiper_container = document.querySelector(".DB-medias .text-container.swiper-container");

            var swiper = new Swiper(_swiper_container, {
                slidesPerView: 1,
                spaceBetween: 50,
                speed:1000,
                loop: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                effect: "creative",
                creativeEffect: {
                    prev: {
                        shadow: false,
                        opacity:0,
                        translate: [0, 0, -400],
                    },
                    next: {
                        shadow: false,
                        opacity:0,
                        translate: [0, 0, 400],
                    },
                },
            });
        }
        
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-medias").length > 0){
        DB_Medias.init();
    }
})